import UserGroupProvider from './UserGroupContext';
import UserGroup from "./UserGroup"

let Index = () => {
    return (
        <UserGroupProvider>
            <UserGroup />
        </UserGroupProvider>
    )
}

export default Index;